import { ProposalHistoryResponseDTO } from "@/services/consignado/dto/proposal-history.dto";
import { getProposalHistoryByProposalId } from "@/services/consignado/proposal-history.service";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Text,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";

interface ILoadingWebhookEventBmpProps {
  balanceSolicitationId: string;
}

export function LoadingWebhookEventBmp({
  balanceSolicitationId,
}: ILoadingWebhookEventBmpProps) {
  const toast = useToast();
  const [webhookLogs, setWebhookLogs] = useState<ProposalHistoryResponseDTO[]>(
    [],
  );

  const fetchLogs = async () => {
    if (webhookLogs.length > 0) return;

    try {
      const response = await getProposalHistoryByProposalId(
        balanceSolicitationId,
      );

      if (!response || response.length === 0) {
        toast({
          title: "Nenhum log de webhook encontrado",
          description:
            "Não foram encontrados logs de webhook para esta solicitação.",
          status: "info",
          duration: 3000,
          isClosable: true,
        });
        return;
      }

      setWebhookLogs(response);
    } catch (error) {
      toast({
        title: "Erro ao carregar logs de webhook",
        description:
          "Não foi possível carregar os logs de webhook para esta solicitação.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <VStack align="stretch" spacing={2} mt="5">
      <Accordion
        allowToggle
        border="1px solid"
        borderColor="gray.200"
        borderRadius="md"
      >
        <AccordionItem border="none">
          <AccordionButton
            p={3}
            _hover={{ bg: "blue.900", color: "white" }}
            borderRadius="md"
            onClick={fetchLogs}
            justifyContent="center"
            bg="blue.800"
            color="white"
            position="relative"
          >
            <Text>Carregar informações de terceiros (webhooks)</Text>
            <Flex position="absolute" right="4">
              <AccordionIcon />
            </Flex>
          </AccordionButton>

          {webhookLogs.map((log, index) => (
            <AccordionPanel px={3} pb="2" key={index}>
              <Box
                p={2}
                bg="gray.50"
                borderRadius="md"
                border="1px solid"
                borderColor="gray.200"
              >
                <Box>
                  <Text fontSize="sm" fontWeight="bold">
                    {`Webhook - ${new Date(log.criado_em).toLocaleString(
                      "pt-BR",
                    )}`}
                  </Text>
                  <Text fontSize="xs" color="gray.500" mt={0.5}>
                    {log.resposta}
                  </Text>
                </Box>
              </Box>
            </AccordionPanel>
          ))}
        </AccordionItem>
      </Accordion>
    </VStack>
  );
}
